import { Component } from '@angular/core';
import { ModalController, AlertController, Events } from 'ionic-angular';
import { AppState } from '../../config/state';
import { CoRoamLoginComponent } from '../co-roam-login/co-roam-login';

@Component({
  selector: 'co-staff-logout',
  templateUrl: 'co-staff-logout.html'
})
export class CoStaffLogoutComponent {

    isStaff=false;
    isStaffAuthorized=false;
    initials="";

    constructor(private _state: AppState, private _modalCtrl: ModalController, private  _alterCtrl: AlertController, private events : Events){
        this.setStaffState();
    }

    setStaffState(){
        this.isStaff=this._state.staff;
        this.isStaffAuthorized=this._state.staffAuthorized;
        if (this._state.staffAuthorized && this._state.staffCredentials && this._state.staffCredentials.details) {
            this.initials=(this._state.staffCredentials.details.firstName ? this._state.staffCredentials.details.firstName.slice(0,1) : "");
            this.initials+=(this._state.staffCredentials.details.lastName ? this._state.staffCredentials.details.lastName.slice(0,1) : "");
        }
    }

    unsetStaffState(){
        this._state.staffAuthorized = false;
        this._state.staffCredentials = {
          username: undefined,
          password: undefined,
          details: undefined
        }
        this.isStaff=false;
        this.isStaffAuthorized=false;
    }

    logout(){
        let alert = this._alterCtrl.create({
            title: 'Logout',
            cssClass:'confirm-alert',
            message: 'Do you want to log out?',
            buttons: [
              {
                text: 'Yes',
                cssClass: 'confirm-button-outline',
                handler: () => {
                    this.events.publish('staff:logout');
                }
              },
              {
                text: 'No',
                role: 'cancel',
                cssClass: 'confirm-button',
                handler: () => {
                  return;
                }
              }
            ]
          });
          alert.present();
    }
}


// WEBPACK FOOTER //
// ./src/components/co-staff-logout/co-staff-logout.ts